import { PublicProject } from "@ecologi/shared";
import {
  carbonAvoidanceSubTypeVisuals,
  carbonAvoidanceVisuals,
} from "./carbon-avoidance-visuals";
import {
  reforestationSubTypeVisuals,
  reforestationVisuals,
} from "./reforestation-visuals";
import { carbonRemovalVisuals } from "./carbon-removal-visuals";
import { habitatRestorationVisuals } from "./habitat-restoration-visuals";

export type ProjectVisualsType = {
  icon: JSX.Element;
  pictogram: string;
  tileImage?: string;
};

export const projectTypeVisuals: Record<
  NonNullable<PublicProject["projectType"]>,
  ProjectVisualsType
> = {
  ...reforestationVisuals,
  ...carbonAvoidanceVisuals,
  ...carbonRemovalVisuals,
  ...habitatRestorationVisuals,
};

export const projectSubTypeVisuals: Record<
  NonNullable<PublicProject["projectSubType"]>,
  ProjectVisualsType
> = {
  ...reforestationSubTypeVisuals,
  ...carbonAvoidanceSubTypeVisuals,
};
